import icon from "images/icons/icon-action.svg"

export default function ActionIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
